import { accordionAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";
import ThemeColorConstant from "constants/ThemeColorsConstant";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(accordionAnatomy.keys);

const custom = definePartsStyle({
  panel: {
    padding: "0px",
    borderTop: "none",
    borderRight: "1rem solid",
    borderBottom: "1rem solid",
    borderLeft: "1rem solid",
    borderColor: ThemeColorConstant.hover_background,
  },
  button: {
    height: "3.5rem",

    _expanded: {
      background: ThemeColorConstant.hover_background,
    },
  },
  icon: {
    color: ThemeColorConstant.secondaryColor,

    _dark: {
      borderColor: "gray.600",
      background: "gray.600",
      color: "gray.400",
    },
  },
});

const ChakraUIAccordionStyling = defineMultiStyleConfig({
  variants: { custom },
});

export default ChakraUIAccordionStyling;

// Now we can use the new `custom` variant
